import { memoize } from 'lodash-es'

export const getFlag = memoize(function getFlag(str: string) {
	const lowerStr = str.toLowerCase()

	return createCodePoint(lowerStr[0]) + createCodePoint(lowerStr[1])
})

function createCodePoint(ch: string) {
	return String.fromCodePoint(
		// biome-ignore lint/style/noNonNullAssertion: <explanation>
		ch.codePointAt(0)! - ('a' as any).codePointAt(0) + 0x1f1e6,
	)
}
